// extracted by mini-css-extract-plugin
export default {"cardSec":"SponsCardSec_cardSec__bvBTN","container":"SponsCardSec_container__o4I2m","main":"SponsCardSec_main__TQWLc","card":"SponsCardSec_card__T+BDB"};